export const SERVER_DATE_KEY = '__SERVER_DATE';

export default __BROWSER__ ? window?.[SERVER_DATE_KEY] : new Date().toISOString();
